export function addIdToOrderLabels(items) {
  return items.map((item) => ({
    ...item,
    id: item.rowId,
  }));
}
